import React, { useCallback, useState } from 'react';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, BarChart,
  Bar,
} from 'recharts';
import { toast } from 'react-toastify';
import { MdPrint } from 'react-icons/md';
import Grid24 from '../../../../UI/Grid24';
import PeriodField from '../../../../UI/Field/Period/PeriodField';
import FieldModel, { DATE } from '../../../../../models/FieldModel';
import MoneyField from '../../../../UI/Field/Money/MoneyField';
import SearchButtonWithLabel from '../../../../UI/Button/Search/Label/SearchButtonWithLabel';
import CheckboxField from '../../../../UI/Field/Checkbox/CheckboxField';
import { GroupDefinitions } from '../BaseCalculo/Honorarios/styles';
import RadioField from '../../../../UI/Field/Radio/RadioField';
import {
  getMoneyMask, openPageFileBase64, toAmericanDate, toBrazilianDate,
} from '../../../../../helpers';
import { buscarEstatisticaCliente, imprimirEstatisticaCliente } from '../../../../../services/core/cliente/cliente.services';
import { WrapperFormWithTitle } from '../../../../../pages/ControleBordero/ResumoMensal/ResumoMensalStyles';
import { ButtonImprimir } from '../../../../../pages/ContaCorrenteCliente/Accordions/NaoPrestados/LancamentosNaoPrestadosStyle';

function EstatisticasDoCliente({
  idCliente,
  isInsertMode,
}) {
  const [dataInicial, setDataInicial] = useState(
    new FieldModel({ name: 'dataInicial', type: DATE, value: toBrazilianDate(new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000)) }),
  );
  const [dataFinal, setDataFinal] = useState(
    new FieldModel({ name: 'dataFinal', type: DATE, value: toBrazilianDate(new Date(new Date().getTime())) }),
  );
  const [valorFinal, setValorFinal] = useState(
    new FieldModel({ name: 'valorFinal', value: '9999999999.99' }),
  );
  const [valorInicial, setValorInicial] = useState(
    new FieldModel({ name: 'valorInicial', value: '0' }),
  );
  const [incluirGrupo, setIncluirGrupo] = useState(
    new FieldModel({ name: 'incluirGrupo', value: false }),
  );
  const [agruparRecebimentos, setAgruparRecebimentos] = useState(
    new FieldModel({ name: 'agruparRecebimentos', value: false }),
  );
  const [definition, setDefinition] = useState('0');

  const [listaEstatisticaCliente, setListaEstatisticaCliente] = useState([]);


  const pesquisarEstatisticarDoCliente = useCallback(() => {
    const payload = {
      dataInicial: toAmericanDate(dataInicial.value),
      dataFinal: toAmericanDate(dataFinal.value),
      valorInicial: valorInicial.value,
      valorFinal: valorFinal.value,
      incluirGrupo: incluirGrupo.value,
      agruparRecebimentos: agruparRecebimentos.value,
      definition,
      idCliente,
    };

    buscarEstatisticaCliente(payload).then((response) => {
      setListaEstatisticaCliente(response.data);
    }).catch(() => {
      toast.warn('Nenhum resultado foi encontrado relacionado à sua pesquisa.');
    });
  }, [dataInicial, dataFinal, valorInicial, valorFinal, incluirGrupo, agruparRecebimentos, definition, idCliente]);

  const arquivoEstatisticaCliente = useCallback(() => {
    const payload = {
      dataInicial: toAmericanDate(dataInicial.value),
      dataFinal: toAmericanDate(dataFinal.value),
      valorInicial: valorInicial.value,
      valorFinal: valorFinal.value,
      incluirGrupo: incluirGrupo.value,
      agruparRecebimentos: agruparRecebimentos.value,
      definition,
      idCliente,
    };

    imprimirEstatisticaCliente(payload).then((response) => {
      openPageFileBase64(response.data, response.headers['content-type']);
    }).catch(() => {
      toast.warn('Nenhum resultado foi encontrado relacionado à sua pesquisa.');
    });
  }, [dataInicial, dataFinal, valorInicial, valorFinal, incluirGrupo, agruparRecebimentos, definition, idCliente]);


  return (
    <>
      <Grid24 container isFormContainer xs={24} sm={24}>
        <Grid24 container isFormContainer xs={24} sm={10}>

          <Grid24 xs={24} sm={15} style={{ marginTop: '20px' }}>
            <SearchButtonWithLabel
              style={{ width: '200px', marginRight: '15px' }}
              disabled={isInsertMode}
              label="Pesquisar"
              type="button"
              onClick={() => { pesquisarEstatisticarDoCliente(); }}
            />
            <ButtonImprimir
              disabled={isInsertMode}
              onClick={arquivoEstatisticaCliente}
            >
              <MdPrint size={16} />
              <span>Imprimir</span>
            </ButtonImprimir>
          </Grid24>
          <Grid24
            xs={24}
            sm={15}
            style={{
              display: 'flex', alignItems: 'center', marginTop: '16px',
            }}
          >
            <span style={{
              fontSize: '16px',
              alignSelf: 'flex-end',
              marginRight: '10px',
              color: 'blue',
              fontWeight: 'bold',
              marginBottom: '10px',
            }}
            >
              Periodo de avaliação:
            </span>
            <PeriodField
              disabled={isInsertMode}
              isForm
              label=""
              firstField={dataInicial}
              lastField={dataFinal}
              onChange={(e) => {
                if (e.target.name === 'dataInicial') {
                  setDataInicial({ ...dataInicial, value: e.target.value });
                }
                if (e.target.name === 'dataFinal') {
                  setDataFinal({ ...dataFinal, value: e.target.value });
                }
              }}
            />
            <span style={{
              fontSize: '16px',
              alignSelf: 'flex-end',
              marginRight: '10px',
              color: 'blue',
              marginTop: '10px',
              fontWeight: 'bold',
            }}
            >
              Intervalo de Valores:
            </span>
            <div style={{ width: '100%', marginTop: '10px' }}>
              <MoneyField
                isForm
                style={{ width: '250px' }}
                disabled={isInsertMode}
                maxlength={16}
                label="De:"
                name={valorInicial.name}
                value={valorInicial.value}
                onChange={(e) => { setValorInicial({ ...valorInicial, value: e.target.value }); }}
              />
            </div>
            <div style={{ width: '100%', marginTop: '10px' }}>
              <MoneyField
                isForm
                style={{ width: '250px' }}
                disabled={isInsertMode}
                maxlength={16}
                label="Até:"
                name={valorFinal.name}
                value={valorFinal.value}
                onChange={(e) => { setValorFinal({ ...valorFinal, value: e.target.value }); }}
              />
            </div>
            <span style={{
              fontSize: '16px',
              alignSelf: 'flex-end',
              marginRight: '10px',
              color: 'blue',
              marginTop: '20px',
              fontWeight: 'bold',
            }}
            >
              Visualização:
            </span>
            <div style={{ width: '100%', marginTop: '10px', marginLeft: '5px' }}>
              <CheckboxField
                disabled={isInsertMode}
                name={incluirGrupo.name}
                checked={incluirGrupo.value}
                label="Incluir todo o grupo"
                onChange={(e) => { setIncluirGrupo({ ...incluirGrupo, value: e.target.checked }); }}
              />
            </div>
            <div style={{ width: '100%', marginTop: '10px', marginLeft: '5px' }}>
              <CheckboxField
                disabled={isInsertMode}
                name={agruparRecebimentos.name}
                checked={agruparRecebimentos.value}
                label="Agrupar Recebimentos"
                onChange={(e) => { setAgruparRecebimentos({ ...agruparRecebimentos, value: e.target.checked }); }}
              />
            </div>
            <span style={{
              fontSize: '16px',
              alignSelf: 'flex-end',
              marginRight: '10px',
              color: 'blue',
              marginTop: '20px',
              fontWeight: 'bold',
            }}
            >
              Status:
            </span>
            <div style={{ width: '100%', marginLeft: '5px' }}>
              <GroupDefinitions
                aria-label="status-definicoes"
                value={definition}
                onChange={e => setDefinition(e.target.value)}
              >
                <Grid24 xs={24} sm={24}>
                  <RadioField
                    disabled={isInsertMode}
                    label="Todos"
                    value="0"
                  />
                </Grid24>
                <Grid24 xs={24} sm={24}>
                  <RadioField
                    disabled={isInsertMode}
                    label="Excluir Não Proc/Estab"
                    value="1"
                  />
                </Grid24>
                <Grid24 xs={24} sm={24}>
                  <RadioField
                    disabled={isInsertMode}
                    label="Excluir Ativos, Não Proc/Estab"
                    value="2"
                  />
                </Grid24>
              </GroupDefinitions>
            </div>

          </Grid24>

        </Grid24>
        <Grid24 container isFormContainer xs={24} sm={11}>
          <div style={{ marginTop: '20px' }}>
            <WrapperFormWithTitle title="Quantidade">
              <BarChart
                width={500}
                height={400}
                data={listaEstatisticaCliente}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="statusProcessos" />
                <YAxis />
                <Tooltip formatter={value => [`Quantidade: ${value}`]} />
                <Bar
                  type="monotone"
                  dataKey="qtdeProcessos"
                  fill="#8884d8"
                />
              </BarChart>
            </WrapperFormWithTitle>
          </div>
        </Grid24>

        <Grid24 container isFormContainer xs={24} sm={24}>
          <div style={{ marginTop: '20px' }}>
            <WrapperFormWithTitle title="Valor Total">
              <BarChart
                width={950}
                height={400}
                data={listaEstatisticaCliente}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="statusProcessos" />
                <YAxis />
                <Tooltip formatter={value => [`Valor Total: ${getMoneyMask(value)}`]} />
                <Bar
                  type="monotone"
                  dataKey="valorTotal"
                  fill="#8884d8"
                />
              </BarChart>
            </WrapperFormWithTitle>
          </div>
        </Grid24>

      </Grid24>

    </>
  );
}

export default React.memo(EstatisticasDoCliente);
